<script>
  export let image;
</script>

<main>
  <img src={image}>
</main>

<style>
  img {
    border-radius: 7px;
    box-shadow: 0 10px 7px -3px #272d35;
    width: 100%;
    max-width: 150%;
    max-height: 750px;
    height: auto;
  }

  main {
    margin: 5px 10px 10px 3px;
    padding: 5px;
    display: block;
  }
</style>

